import React from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { MSpinner } from "components/Shared";
import AppraiserProfileEdit from "components/Appraiser/AppraiserProfileEdit";
import AppInsightsTracker from "components/Shared/AppInsightsTracker";

// This is a class-based component because the current
// version of hot reloading won't hot reload a stateless
// component at the top-level.
class AppraiserProfile extends AppInsightsTracker {
    constructor(props) {
        super(props);
        this.displayName = "AppraiserProfile";
    }

    componentDidMount() {
        if (this.props.location.state && this.props.location.state.id !== null) {
            let id = this.props.location.state.id;
            this.props.getAppraiserProfile(id);
            if (this.props.location.state.internetUserId) {
                this.props.getUser(this.props.location.state.internetUserId);
            }
        } else if (!this.props.appraiserProfile.appraiserId) {
            this.props.history.push({ pathname: "/" });
        }
    }

    render() {
        const {
            fetchingAppraiserProfile, fetchingAppraiserManagers, fetchingCertificateList, fetchingDesignationList,
            fetchingStateList, isFetchingInternetUser, internetUser, fetchingAppraiserCounties
        } = this.props;

        if (fetchingAppraiserProfile
            || fetchingAppraiserManagers
            || fetchingCertificateList
            || fetchingDesignationList
            || fetchingStateList
            || isFetchingInternetUser
            || !internetUser
            || fetchingAppraiserCounties) {
            return <MSpinner />;
        }

        return (
            <div>
                <AppraiserProfileEdit />
            </div>
        );
    }
}

AppraiserProfile.propTypes = {
    fetchingAppraiserProfile: PropTypes.bool.isRequired,
    appraiserProfile: PropTypes.object.isRequired,
    getAppraiserProfile: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    isFetchingInternetUser: PropTypes.bool.isRequired,
    internetUser: PropTypes.object.isRequired,
    fetchingAppraiserCounties: PropTypes.bool.isRequired,
    fetchingAppraiserManagers: PropTypes.bool.isRequired,
    fetchingCertificateList: PropTypes.bool.isRequired,
    fetchingDesignationList: PropTypes.bool.isRequired,
    fetchingStateList: PropTypes.bool.isRequired,
    getUser: PropTypes.func.isRequired,
};

export default withRouter(AppraiserProfile);
